import { render, staticRenderFns } from "./EnrollmentProgramList.vue?vue&type=template&id=c3475486&scoped=true&"
import script from "./EnrollmentProgramList.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentProgramList.vue?vue&type=script&lang=ts&"
import style0 from "./EnrollmentProgramList.vue?vue&type=style&index=0&id=c3475486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3475486",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarTitle } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VAppBar,VAppBarTitle,VBtn,VCard,VCardSubtitle,VIcon})
